angular.module('nv.shared.modals').factory('LoteSchedulerModal', LoteSchedulerModal);

function LoteSchedulerModal($mdDialog) {
  let examName;

  function formatLoteExamLanguage(examName) {
    if (!examName) {
      return '';
    } else {
      let formattedExamName = examName[0].toUpperCase() + examName.slice(1, examName.length).toLowerCase();

      if (_.includes(formattedExamName, '-')) {
        const formattedExamNameSplit = formattedExamName.split('-');

        formattedExamName = `${formattedExamNameSplit[0]}-${formatLoteExamLanguage(formattedExamNameSplit[1])}`;
      }

      return formattedExamName;
    }
  }

  return {
    show(_examName) {
      examName = _examName;

      const customModal = {
        controller: 'LoteSchedulerCtrl',
        template: require('./lote-scheduler.html'),
      };

      return $mdDialog.show(customModal);
    },

    getExamName() {
      return examName;
    },

    getFormattedExamName(_examName = examName) {
      return formatLoteExamLanguage(_examName);
    },
  };
}
